import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceAnimalSacrifice from '../../components/ServiceAnimalSacrifice'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const ServiceAnimalSacrificePage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/>
            <ServiceAnimalSacrifice/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceAnimalSacrificePage;
